document.addEventListener('DOMContentLoaded', function() {
  // Get all menu summary elements
  const menuSummaries = document.querySelectorAll('header-menu summary');
  
  menuSummaries.forEach(function(summary) {
    // Store the original click handler (though it's being completely replaced here)
    const originalClickHandler = summary.onclick;
    
    // Add mouseover/mouseout handlers for hover functionality
    summary.parentElement.addEventListener('mouseover', function() {
      this.setAttribute('open', true);
    });
    
    summary.parentElement.addEventListener('mouseout', function() {
      this.setAttribute('open', false);
    });
    
    // Replace the click handler to handle navigation
    summary.onclick = function(e) {
      // Prevent the default behavior (which would just toggle the dropdown)
      e.preventDefault();
      e.stopPropagation(); // Stop the event from bubbling up
      
      // Get the ID from the summary element
      const id = summary.getAttribute('id');
      let url = '';
      
      // If an ID exists, extract the handle and determine the URL
      if (id) {
        const handle = id.replace('HeaderMenu-', ''); // Extracts 'shameless-sex' from 'HeaderMenu-shameless-sex'
        
        // Custom logic for the "SHAMELESS SEX" menu item
        if (handle === 'shameless-sex') { 
          url = 'http://ppshop.biz/pages/meet-amy-april';
        } else {
          // Default logic for all other top-level menu items with sub-links
          // Assumes they should link to a collection with a matching handle
          url = '/collections/' + handle;
        }
      }
      
      // Navigate to the determined URL
      if (url) {
        window.location.href = url;
      }
      
      return false; // Prevent any further default actions
    };
  });
});